module.exports = __webpack_public_path__ + "static/media/Bluelab_IntelliDose_img.aeb31930.webp";